import { expectRecord, expectString } from "./schema";
import { parseTenantServiceCategory, parseTenantUiLabelProfile } from "./tenant-metadata";
export function parseTenantContext(value, path = "tenant") {
    const record = expectRecord(value, path);
    return {
        tenantId: expectString(record.tenantId, `${path}.tenantId`),
        tenantSlug: expectString(record.tenantSlug, `${path}.tenantSlug`),
        displayName: expectString(record.displayName, `${path}.displayName`),
        serviceCategory: parseTenantServiceCategory(record.serviceCategory, `${path}.serviceCategory`),
        uiLabelProfile: parseTenantUiLabelProfile(record.uiLabelProfile, `${path}.uiLabelProfile`)
    };
}
